import { render, staticRenderFns } from "./comTerm10.vue?vue&type=template&id=742d69c1&scoped=true&"
import script from "./comTerm10.vue?vue&type=script&lang=js&"
export * from "./comTerm10.vue?vue&type=script&lang=js&"
import style0 from "./comTerm10.vue?vue&type=style&index=0&id=742d69c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d69c1",
  null
  
)

export default component.exports